import { requestStatuses } from '../../utils/constants';
import { RootState } from '../../types';

const all = (state: RootState) => state.games.history;
export const list = (state: RootState) => all(state).list;
export const loading = (state: RootState) => all(state).loading;
export const init = (state: RootState) =>
  all(state).status === requestStatuses.init;
